import React, { FC, useState } from 'react'
import { IonSegment, IonSegmentButton, IonLabel } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'

interface ITypeItem {
  value: string;
  label: string;
}

interface IProps {
  types: ITypeItem[];
  defaultType?: string;
  onChange?: (val: string) => any;
}
interface IState {
  type: string;
}

const Tabs: FC<IProps> = (props) => {
  const {
    types,
    defaultType,
    onChange
  } = props
  const initialState: IState = {
    type: defaultType || types[0].value
  }
  const [type, setType] = useState(initialState.type)
  // type change
  const handleChange = (val: any) => {
    setType(val)
    onChange && onChange(val)
  }
  return (
    <>
      <IonSegment className='mkt-switch-tab' onIonChange={(e: any) => handleChange(e.detail.value)} value={type}>
        {
          types.map((item: any) => (
            <IonSegmentButton className='mkt-segment-btn button' key={item.value} value={item.value}>
              <IonLabel>{item.label}</IonLabel>
            </IonSegmentButton>
          ))
        }
      </IonSegment>
    </>
  )
}

export default observer(Tabs)
